import React from 'react';

const LocationPoint: React.FC = () => {
  return (
    <svg
      className="w-3 h-3"
      viewBox="0 0 8 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.85602 4.81149C3.13047 5.06879 3.45638 5.19744 3.83376 5.19744C4.21113 5.19744 4.53275 5.0645 4.79863 4.79863C5.0645 4.53275 5.19744 4.21113 5.19744 3.83376C5.19744 3.45638 5.0645 3.13476 4.79863 2.86888C4.53275 2.60301 4.21113 2.47007 3.83376 2.47007C3.45638 2.47007 3.13476 2.60301 2.86888 2.86888C2.60301 3.13476 2.47007 3.45638 2.47007 3.83376C2.47007 4.21113 2.59872 4.53704 2.85602 4.81149ZM1.10639 1.13212C1.86113 0.377368 2.77025 0 3.83376 0C4.89726 0 5.80209 0.37308 6.54826 1.11925C7.29443 1.86542 7.66751 2.77025 7.66751 3.83376C7.66751 4.36551 7.53457 4.97444 7.2687 5.66058C7.00282 6.34671 6.6812 6.98995 6.30383 7.59032C5.92645 8.19069 5.55337 8.75245 5.18458 9.27563C4.81578 9.79881 4.50273 10.2148 4.24543 10.5235L3.83376 10.9609C3.73084 10.8409 3.59361 10.6822 3.42208 10.4849C3.25054 10.2877 2.94179 9.89315 2.4958 9.30136C2.04981 8.70957 1.65958 8.13494 1.32509 7.57746C0.9906 7.01997 0.686132 6.3896 0.411678 5.68631C0.137225 4.98302 0 4.36551 0 3.83376C0 2.77025 0.368791 1.86971 1.10639 1.13212Z"
        fill="#4B5563"
      />
    </svg>
  );
};

export default LocationPoint;
